<template>
  <div class="modern-thermo-icon__container" v-tooltip="{ content: value * 100 + '%' }">
    <div :class="['modern-thermo-icon', getScoreClass(value), { 'large-size': isLarge }]"></div>
  </div>
</template>

<script>
import tenderScoreMixin from '@/mixins/tender-score-mixin';

export default {
  name: 'DynamicThermometer',
  mixins: [tenderScoreMixin],
  components: {},
  props: {
    // value should range from 0 to 1
    value: {
      type: Number,
      required: true,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.modern-thermo-icon {
  margin-top: 8px;

  &__container {
    width: 12px;
    height: 24px;
  }
}

.modern-thermo-icon,
.modern-thermo-icon:after,
.modern-thermo-icon:before {
  background-color: $color-border;
  border-radius: 1px;
  position: absolute;
  width: 6px;
  height: 6px;
}

.modern-thermo-icon {
  color: #000;

  &.poor {
    &::after {
      background-color: rgba($color-neutral, 1);
    }
  }

  &.moderate {
    background-color: rgba($color-success, 0.55);

    &::after {
      background-color: rgba($color-success, 0.55);
    }

    &::before {
      background-color: $color-border;
    }
  }

  &.strong {
    background-color: rgba($color-success, 1);

    &::before,
    &::after {
      background-color: rgba($color-success, 1);
    }
  }
  &.large-size {
    width: $font-size-xxxsmall;
    height: $font-size-xxxsmall;
    &::after,
    &::before {
      width: $font-size-xxxsmall;
      height: $font-size-xxxsmall;
    }
    &::after {
      margin-top: 2px;
    }
    &::before {
      margin-top: -2px;
    }
  }
}
.modern-thermo-icon:before {
  content: '';
  top: -8px;

  &.strong {
    background-color: rgba($color-success, 1);
  }
  &.moderate {
    background-color: rgba($color-success, 0.2);
  }
}
.modern-thermo-icon:after {
  content: '';
  top: 8px;
}
</style>
